export const backgrounds = [
  "https://i.imgur.com/Xw7Ngdo.jpg",
  "https://i.imgur.com/AT5TUjr.jpg",
  "https://i.imgur.com/KT6Irnk.jpg",
  "https://i.imgur.com/6QVeI5L.jpg",
  "https://i.imgur.com/WicsvKD.jpg",
  "https://i.imgur.com/dRA1Myi.jpg",
  "https://i.imgur.com/70VFEXg.jpg",
  "https://i.imgur.com/ufmMcGz.jpg",
  "https://i.imgur.com/8S01lCL.jpg",
  "https://i.imgur.com/mILEX1q.jpg",
  "https://i.imgur.com/75oQwb3.jpg",
  "https://i.imgur.com/RHIi7mp.jpg",
  "https://i.imgur.com/SeNzmEn.jpg",
  "https://i.imgur.com/ZnNJrGd.jpg",
  "https://i.imgur.com/ruMI1QG.jpg",
  "https://i.imgur.com/JSzcEDQ.jpg",
  "https://i.imgur.com/rAKZy5k.jpg",
  "https://i.imgur.com/FFEv9dR.jpg",
  "https://i.imgur.com/9wKj6aK.jpg",
  "https://i.imgur.com/em27SHM.jpg",
  "https://i.imgur.com/eP19CXG.jpg",
  "https://i.imgur.com/ee1gPHt.jpg",
  "https://i.imgur.com/u8ipgU4.jpg",
  "https://i.imgur.com/JH1YInJ.jpg",
  "https://i.imgur.com/Xw7Ngdo.jpg",
  "https://i.imgur.com/AT5TUjr.jpg",
  "https://i.imgur.com/KT6Irnk.jpg",
  "https://i.imgur.com/6QVeI5L.jpg",
  "https://i.imgur.com/WicsvKD.jpg",
  "https://i.imgur.com/dRA1Myi.jpg",
  "https://i.imgur.com/WicsvKD.jpg",
];
